import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../payee-input/payee-input.directive';
import { TranslateModule } from '@ngx-translate/core';

export type CloseCaseConfirmDialogData = {
  showCloseReason?: boolean;
};

export type CloseCaseConfirmResult = {
  message?: string;
};

@Component({
  selector: 'app-close-case-confirm',
  templateUrl: './close-case-confirm.component.html',
  styleUrls: ['./close-case.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    ReactiveFormsModule,
    MatDialogClose,
    TranslateModule,
  ],
})
export class CloseCaseConfirmComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<CloseCaseConfirmComponent, CloseCaseConfirmResult>>(
    MatDialogRef,
  );
  private destroyRef = inject(DestroyRef);
  readonly data = inject<CloseCaseConfirmDialogData>(MAT_DIALOG_DATA, { optional: true });

  readonly showCloseReason = this.data?.showCloseReason ?? false;
  readonly closeReasonForm = new FormControl('', { nonNullable: true });
  confirmDisabled = true;
  submitted = false;

  ngOnInit() {
    timer(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.confirmDisabled = false;
      });
  }

  get actionsDisabled(): boolean {
    return this.confirmDisabled || this.submitted;
  }

  readonly confirm = () => {
    if (this.actionsDisabled) {
      return;
    }

    this.submitted = true;

    const message = this.showCloseReason ? this.closeReasonForm.value.trim() : undefined;
    this.dialogRef.close(message ? { message } : {});
  };
}
